/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BuildsIndicator_pipeline$ref: FragmentReference;
declare export opaque type BuildsIndicator_pipeline$fragmentType: BuildsIndicator_pipeline$ref;
export type BuildsIndicator_pipeline = {|
  +id: string,
  +uuid: string,
  +scheduledBuilds: ?{|
    +count: number
  |},
  +runningBuilds: ?{|
    +count: number
  |},
  +$refType: BuildsIndicator_pipeline$ref,
|};
export type BuildsIndicator_pipeline$data = BuildsIndicator_pipeline;
export type BuildsIndicator_pipeline$key = {
  +$data?: BuildsIndicator_pipeline$data,
  +$fragmentRefs: BuildsIndicator_pipeline$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuildsIndicator_pipeline",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": "scheduledBuilds",
      "args": [
        {
          "kind": "Literal",
          "name": "state",
          "value": "SCHEDULED"
        }
      ],
      "concreteType": "BuildConnection",
      "kind": "LinkedField",
      "name": "builds",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "builds(state:\"SCHEDULED\")"
    },
    {
      "alias": "runningBuilds",
      "args": [
        {
          "kind": "Literal",
          "name": "state",
          "value": [
            "RUNNING",
            "FAILING"
          ]
        }
      ],
      "concreteType": "BuildConnection",
      "kind": "LinkedField",
      "name": "builds",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "builds(state:[\"RUNNING\",\"FAILING\"])"
    }
  ],
  "type": "Pipeline",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dd4daba76fd0e9f9bb77feecab62d31b';

module.exports = node;
